import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=4e145b0a&scoped=true&"
var script = {}
import style0 from "./Description.vue?vue&type=style&index=0&id=4e145b0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e145b0a",
  null
  
)

export default component.exports